import InfoIcon from '@8x8/oxygen-icon/novo/InfoCircleIcon'
import Tooltip from '@8x8/oxygen-tooltip'
import React from 'react'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import Button from '~/components/common/button'
import Input from '~/components/common/input'
import Modal from '~/components/common/modal'
import { hideDialog } from '~/actions/ui'
import { ColumnFlex } from '~/components/common/containers'

const PersonalRoomNameLabel = styled.div`
  display: flex;
  ${({ theme }) => ({ ...theme._neo.bodyBold02 })}
`

const StyledInput = styled(Input)`
  margin-top: 4px;
  margin-bottom: 0;
  display: flex;
`

const PersonalRoomPasswordLabelWrapper = styled.div`
  margin-top: 48px;
  display: flex;
  ${({ theme }) => ({ ...theme._neo.bodyBold02 })}
  justify-content: left;
`

const PersonalRoomPasswordInputWrapper = styled.div`
  margin-top: 4px;
  display: flex;
`

const PersonalRoomPasswordLabel = styled.div`
  margin-right: 5px;
  text-align: left;
`

const ToolTipTarget = styled.div`
  width: 24px;
  height: 24px;
  display: inline-block;
`

const StyledButton = styled(Button)`
  min-width: 120px;
`

const ErrorLabel = styled.div`
  display: flex;
  font-weight: 600;
  font-size: ${({ theme }) => theme._neo.label01.fontSize};
  line-height: 20px;
  color: ${props => props.theme.colorError};
`

const MainScreen = ({
  editedRoomName,
  editedPassword,
  personalRoom,
  password,
  onRoomNameChange,
  onPasswordChange,
  onSave,
  passwordHasErrors,
  roomNameHasErrors
}) => {
  const getRoomNameValidationError = () => {
    let roomNameErrorMessage
    if (roomNameHasErrors) {
      if (!editedRoomName.length) {
        roomNameErrorMessage = translate('room_name_empty')
      } else if (editedRoomName.length === 1 || ['.', '_', '-'].includes(editedRoomName[0])) {
        roomNameErrorMessage = translate('should_not_start_with_special_char')
      } else {
        roomNameErrorMessage = translate('invalid_character')
      }
    }
    return roomNameErrorMessage
  }

  const hasEdits = personalRoom !== editedRoomName || password !== editedPassword

  return (
    <Modal
      footerChildren={(
        <>
          <StyledButton
            onClick={onSave}
            isDisabled={!hasEdits || passwordHasErrors || roomNameHasErrors}
          >
            {translate('save')}
          </StyledButton>
          <StyledButton secondary onClick={hideDialog}>
            {translate('cancel')}
          </StyledButton>
        </>
      )}
      title={translate('edit_personal_meeting_space')}
    >
      <ColumnFlex>
        <PersonalRoomNameLabel>{translate('personal_meeting_space_name')}</PersonalRoomNameLabel>
        <div data-test-id='personal-space-name'>
          <StyledInput
            onChange={onRoomNameChange}
            placeholder={translate('none')}
            value={editedRoomName}
            maxLength={640}
            fullWidth
            hasErrors={roomNameHasErrors}
          />
        </div>
        {roomNameHasErrors && <ErrorLabel>{getRoomNameValidationError()}</ErrorLabel>}
        <PersonalRoomPasswordLabelWrapper>
          <PersonalRoomPasswordLabel>{translate('participants_password')}</PersonalRoomPasswordLabel>
          <Tooltip
            delay={300}
            title={translate('tooltip_meeting_passcode')}
            orientation='bottom'
            showOn='hover'
          >
            <ToolTipTarget>
              <InfoIcon />
            </ToolTipTarget>
          </Tooltip>
        </PersonalRoomPasswordLabelWrapper>
        <PersonalRoomPasswordInputWrapper
          data-test-id='personal-space-passcode'
        >
          <Input
            onChange={onPasswordChange}
            placeholder={translate('none')}
            value={editedPassword}
            maxLength={640}
            fullWidth
            hasError={passwordHasErrors}
          />
        </PersonalRoomPasswordInputWrapper>
        {passwordHasErrors && <ErrorLabel>{translate('password_validation_error')}</ErrorLabel>}
      </ColumnFlex>
    </Modal>
  )
}

export default MainScreen
